import React, { useState } from 'react';
import Header from './Bootstrap/Header';
import Code from './Code';
import Form from './Form';
import he from 'he';
import Preview from './Preview';
import Portfolio from './Portfolio';
import './Portfolio_Form.css';
import { loadFromLocalStorage, saveToLocalStorage } from '../../../utils/localStorage';

const Portfolio_Form = () => {
  const [dark, setDark] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [showComponent, setShowComponent] = useState(false);
  const [formData, setFormData] = useState(loadFromLocalStorage('portfolio', {
    Name: '',
    FatherName: '',
    Email: '',
    Phone: '',
    Address: '',
    City: '',
    State: '',
    Country: '',
    Description: '',
    Thumbnail: '',
    Colour: '',
    URL: '',
    Facebook: '',
    Instagram: '',
    Twitter: '',
    LinkedIn: '',
     
    Education: [],
  }));
  // const [formData, setFormData] = useState({
  //   Name: '',
  //   FatherName: '',
  //   Email: '',
  //   Phone: '',
  //   Address: '',
  //   City: '',
  //   State: '',
  //   Country: '',
  //   Description: '',
  //   Thumbnail: '',
  //   Colour: '',
  //   URL: '',
  //   Facebook: '',
  //   Instagram: '',
  //   Twitter: '',
  //   LinkedIn: '',
  //   // Socials: {
  //   //   Facebook: 'xyz',
  //   //   WhatsApp: 'xyz',
  //   //   Instagram: 'xyz',
  //   //   Twitter: 'xyz',
  //   //   LinkedIn: 'xyz',
  //   //   GitHub: 'xyz',
  //   //   StackOverflow: 'xyz',
  //   // },
  //   Education: [],
  // });
  const [fileDownloadUrl, setFileDownloadUrl] = useState(null);
  const [previewMode, setPreviewMode] = useState(false);
  const doFileDownload = React.createRef(null);

  const toggleHeader = () => {
    setDark((prevDark) => !prevDark);
  };

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    const updateData = {
      ...formData,
      [name]: type === "file" ? URL.createObjectURL(files[0]) : value,
    };
    setFormData(updateData);
    saveToLocalStorage('portfolio', updateData);
    setPreviewMode(false);
  };


  const download = () => {
    let output = he.decode(
      document.getElementsByClassName('codefile')[0].innerHTML
    );
    const blob = new Blob([output]);
    const newFileDownloadUrl = URL.createObjectURL(blob);
    setFileDownloadUrl(newFileDownloadUrl);
    doFileDownload.current.click();
    URL.revokeObjectURL(newFileDownloadUrl);
    setFileDownloadUrl(null);
    setShowComponent(true);
  };

  const handleButtonClick = () => {
    setShowComponent(true);
    download();
  };

  const editPortfolio = () => {
    setIsEditing(true);
    setIsSubmitted(false);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    setIsSubmitted(true);
  };

  return (
    <div
      style={{
        // backgroundImage: `url(https://images.unsplash.com/photo-1482053450283-3e0b78b09a70?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)`,
        // backgroundSize: 'cover',
        // backgroundPosition: 'center',
        // backgroundRepeat: 'repeat',
        // height: '100vn',
        // paddingTop: '60px',
        marginleft: '20%',
        width: '100vw',
        // width:'100%',
        backgroundColor: '#f7f7f7',
        // overflow: 'hidden' ,
        // minHeight: '100vh'
      }}
      className="">
      <Header dark={dark} className=" ">
        <span class="heading_portfolio"></span>
      </Header>
      {/* <div className="container mx-auto p-4 md:p-6 lg:p-8 portfoliocontainer"> */}
      <>
        {isSubmitted ? (
          <div className="portfolio_view">
            <Portfolio formData={formData} onEdit={editPortfolio} />
          </div>
        ) : (
          <div className="Portfolio_form_container flex flex-col lg:flex-row">
            {/* Form Section */}
            <div className="p-3 w-full lg:w-1/3">
              <Form
                FormData={{
                  FullName: `${formData.FirstName} ${formData.LastName}`,
                  ...formData,
                }}
                onViewPortfolio={handleFormSubmit}
                onChange={handleChange}
              />
              {/* <div className="btn-form">
              <button
                className="btn btn-success"
                onClick={handleFormSubmit}
              >
                View Portfolio
              </button>
              </div> */}
            </div>
            {/* Code/Preview Section */}
            <div className="p-3 w-full lg:w-2/3">
              {previewMode ? (
                <Preview
                  {...formData}
                  FullName={`${formData.FirstName} ${formData.LastName}`}
                />
              ) : (
                <Code
                  {...formData}
                  FullName={`${formData.FirstName} ${formData.LastName}`}
                />
              )}
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default Portfolio_Form;
